export default __webpack_public_path__ + "b492c3208475bd60c27062c3728da421.pdf";